export default "__VITE_ASSET__64853f1d__"